var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetOnMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.453,
    height: 17.143,
    viewBox: "0 0 15.453 17.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location",
    transform: "translate(0 1.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1648",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1648",
    d: "M14.135,357.171a.453.453,0,1,0-.436.794c.539.3.849.625.849.9,0,.338-.479.862-1.823,1.319a16.165,16.165,0,0,1-5,.7,16.165,16.165,0,0,1-5-.7c-1.344-.457-1.823-.981-1.823-1.319,0-.276.309-.6.849-.9a.453.453,0,0,0-.436-.794A2.154,2.154,0,0,0,0,358.866c0,.615.423,1.492,2.438,2.176a17.078,17.078,0,0,0,5.289.748,17.078,17.078,0,0,0,5.289-.748c2.015-.684,2.438-1.561,2.438-2.176A2.153,2.153,0,0,0,14.135,357.171Z",
    transform: "translate(0 -346.337)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1649",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1649",
    d: "M88.3,343.366a14.71,14.71,0,0,0,6.836,0c1.124-.318,1.694-.777,1.694-1.366s-.57-1.049-1.694-1.366c-.25-.071-.521-.132-.81-.185q-.235.406-.493.836c.319.048.619.107.892.176a2.312,2.312,0,0,1,1.192.539,2.311,2.311,0,0,1-1.192.539,12.5,12.5,0,0,1-2.852.323c-.051,0-.1.006-.155.006s-.1,0-.155-.006a12.5,12.5,0,0,1-2.852-.323A2.311,2.311,0,0,1,87.523,342a2.312,2.312,0,0,1,1.192-.539c.272-.069.572-.128.892-.176q-.258-.43-.493-.836c-.289.053-.56.115-.81.185-1.124.318-1.694.777-1.694,1.366S87.18,343.048,88.3,343.366Z",
    transform: "translate(-83.996 -330.173)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1650",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1650",
    d: "M121.261,13.171a1.273,1.273,0,0,0,1.094-.614C124,9.865,125.963,6.316,125.963,4.7a4.7,4.7,0,0,0-9.4,0c0,1.615,1.962,5.163,3.607,7.856A1.273,1.273,0,0,0,121.261,13.171Zm-1.89-8.792a1.89,1.89,0,1,1,1.89,1.89A1.892,1.892,0,0,1,119.372,4.379Z",
    transform: "translate(-113.535 -1.69)",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetOnMap);
export default __webpack_public_path__ + "static/media/set_on_map.87490162c7eae80e8ac19f226557ca6d.svg";
export { ForwardRef as ReactComponent };